import * as bootstrap from 'bootstrap/dist/js/bootstrap.esm.js';
import { darkMode } from './layout/dark-mode.js';
import { imageModal } from './layout/image-modal.js';
import { initSkin, updateSkin } from './components/theme.js';

// Expose bootstrap globally for inline scripts
window.bootstrap = bootstrap;

// Create the theme module
const AsteroUI = (function () {
  let initialized = false;
  // Initialize Bootstrap components
  function initBootstrap() {
    // Enable tooltips everywhere
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    Array.from(tooltipTriggerList).forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Enable popovers everywhere
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    Array.from(popoverTriggerList).forEach((popoverTriggerEl) => {
      new bootstrap.Popover(popoverTriggerEl);
    });
  }

  // Initialize dropdown submenus for mobile compatibility
  function initDropdownSubmenus() {
    // Handle submenu toggles to prevent navigation on mobile
    const submenuToggles = document.querySelectorAll('.dropdown-submenu .dropdown-toggle[data-bs-toggle="dropdown"]');

    submenuToggles.forEach((toggle) => {
      toggle.addEventListener(
        'click',
        function (e) {
          // Prevent default behavior for links
          e.preventDefault();

          // Stop propagation to prevent Bootstrap dropdown from closing the main menu
          e.stopPropagation();

          // Handle the submenu toggle
          const parentLi = this.closest('.dropdown-submenu');

          if (parentLi) {
            // Close other submenus at the same level
            const siblingSubmenus = parentLi.parentElement.querySelectorAll('.dropdown-submenu.show');
            siblingSubmenus.forEach((sibling) => {
              if (sibling !== parentLi) {
                sibling.classList.remove('show');
                const siblingToggle = sibling.querySelector('.dropdown-toggle');
                if (siblingToggle) {
                  siblingToggle.setAttribute('aria-expanded', 'false');
                }
              }
            });

            // Toggle current submenu
            const wasShown = parentLi.classList.contains('show');
            parentLi.classList.toggle('show');

            // Update aria-expanded
            const isExpanded = parentLi.classList.contains('show');
            this.setAttribute('aria-expanded', isExpanded);

            // If we're hiding the submenu, remove focus to prevent :focus-within from keeping it visible
            if (wasShown && !isExpanded) {
              this.blur();
            }
          }
        },
        true
      ); // Use capture phase to handle before Bootstrap
    });

    // Close submenus when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.dropdown-submenu')) {
        const openSubmenus = document.querySelectorAll('.dropdown-submenu.show');
        openSubmenus.forEach((submenu) => {
          submenu.classList.remove('show');
          const toggle = submenu.querySelector('.dropdown-toggle');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.blur(); // Remove focus to prevent :focus-within from keeping submenu visible
          }
        });
      }
    });
  }

  function initializeAll() {
    if (initialized) {
      return;
    }

    try {
      darkMode();
      imageModal();
      initBootstrap();
      initDropdownSubmenus();

      // Initialize skin system
      initSkin();

      initialized = true;
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  }

  // Public API
  return {
    init: initializeAll,
    isInitialized: () => initialized,
    updateSkin: updateSkin
  };
})();

// Auto-initialize when DOM is ready
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AsteroUI.init);
  } else {
    AsteroUI.init();
  }
}

export default AsteroUI;
